import { getAssessmentById } from '@/data/assessments'
import { AssessmentDetailPage } from './AssessmentDetailPage'

export function CloudAssessment() {
  const assessment = getAssessmentById('cloud')!
  return <AssessmentDetailPage assessment={assessment} />
}
